import useNotificationHandler from "hooks/useNotificationHandler";
import { QUERY_KEYS } from "library/shared";
import { IBenefitPackageView } from "library/types";
import { UseQueryResult, useQuery, useQueryClient } from "react-query";
import api from "service/api";

type Params = {
  countryCode: number | string | null;
  clientInternalNumberGOS: number | string;
  enabled?: boolean;
};

const getCompanyPackages = async ({
  countryCode,
  clientInternalNumberGOS,
}: Params) => {
  if (countryCode === null || clientInternalNumberGOS === null) return;
  const response = await api.get(
    `/company/benefitpackage/view/${countryCode}/${clientInternalNumberGOS}`
  );
  return response.data;
};

export function useGetCompanyBenefitPackages({
  countryCode,
  clientInternalNumberGOS,
  enabled = true,
}: Params): UseQueryResult<IBenefitPackageView[]> {
  const { handleAddAxiosErrorNotification } = useNotificationHandler();

  return useQuery<IBenefitPackageView[], Error>(
    [QUERY_KEYS.companyPackages, countryCode, clientInternalNumberGOS],
    () => getCompanyPackages({ countryCode, clientInternalNumberGOS }),
    {
      refetchOnMount: true,

      // cacheTime: 0,
      enabled: enabled,
      onError: (error: any) => {
        handleAddAxiosErrorNotification(error);
      },
    }
  );
}

export const useInvalidateCompanyPackages = () => {
  const queryClient = useQueryClient();
  return () =>
    queryClient.invalidateQueries({ queryKey: QUERY_KEYS.companyPackages });
};
